var map = {
	"./views/Dashboard.vue": [
		573,
		573
	],
	"./views/Login.vue": [
		7879
	],
	"./views/Main.vue": [
		9688
	],
	"./views/activity/banner.vue": [
		7078,
		78
	],
	"./views/activity/index.vue": [
		9927,
		927
	],
	"./views/activity/registrationList.vue": [
		1928,
		928
	],
	"./views/activity/type.vue": [
		2754,
		754
	],
	"./views/connection/index.vue": [
		8294,
		294
	],
	"./views/consumer/apply.vue": [
		9861,
		861
	],
	"./views/consumer/components/Point.vue": [
		7804,
		42
	],
	"./views/consumer/components/Team.vue": [
		6601,
		601
	],
	"./views/consumer/details.vue": [
		4951,
		951
	],
	"./views/consumer/marginLog.vue": [
		5557,
		938
	],
	"./views/consumer/students.vue": [
		52,
		52
	],
	"./views/consumer/teachers.vue": [
		6577,
		577
	],
	"./views/dept/list.vue": [
		2166,
		166
	],
	"./views/information/library.vue": [
		9908,
		908
	],
	"./views/information/orgBank.vue": [
		6804,
		423
	],
	"./views/integral/classification.vue": [
		8614,
		614
	],
	"./views/integral/commodity.vue": [
		5156,
		156
	],
	"./views/integral/log.vue": [
		9204,
		204
	],
	"./views/integral/manageCommodity.vue": [
		6324,
		324
	],
	"./views/integral/orders.vue": [
		6276,
		276
	],
	"./views/integral/reimburse.vue": [
		4741,
		741
	],
	"./views/logs/list.vue": [
		5804,
		804
	],
	"./views/menu/list.vue": [
		8091,
		91
	],
	"./views/menu/list/tenant.vue": [
		28,
		28
	],
	"./views/model/list.vue": [
		1821,
		821
	],
	"./views/notices/index.vue": [
		3142,
		142
	],
	"./views/order/afterSale.vue": [
		7572,
		572
	],
	"./views/order/task.vue": [
		4082,
		316
	],
	"./views/resource/list.vue": [
		318,
		318
	],
	"./views/role/list.vue": [
		4908,
		395,
		527
	],
	"./views/settings/components/agreement.vue": [
		9570,
		570
	],
	"./views/settings/gradeSubjects.vue": [
		1052,
		671
	],
	"./views/settings/help.vue": [
		9492,
		492
	],
	"./views/settings/sysConfig.vue": [
		3557,
		557
	],
	"./views/tenant/list.vue": [
		5308,
		395,
		308
	],
	"./views/user/list.vue": [
		7917,
		917
	],
	"./views/vip/list.vue": [
		4876,
		876
	],
	"./views/vip/orders.vue": [
		2237,
		237
	],
	"./views/withdrawal/income.vue": [
		1187,
		777
	],
	"./views/withdrawal/margin.vue": [
		257,
		257
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5684;
module.exports = webpackAsyncContext;